function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.195 17.622l-8.247-14.25a2.25 2.25 0 00-3.895 0l-8.248 14.25A2.25 2.25 0 003.752 21h16.496a2.25 2.25 0 001.947-3.377zM11.249 9.75a.75.75 0 111.5 0v3.75a.75.75 0 01-1.5 0zM12 18a1.125 1.125 0 110-2.25A1.125 1.125 0 0112 18z",
    fill: props.fill
  }));
}

export default SvgWarning;